<script setup>
defineProps(['item']);
const emit = defineEmits(['open-link']);
</script>

<template>
    <div>
        <div class="text-subtitle-1 text-primary mb-3 font-weight-bold">
            <v-icon v-if="item?.icon">{{ item?.icon }}</v-icon>
            {{ item?.title }}
        </div>
        <div
            v-for="(data, i) in item?.data"
            :key="i"
            class="d-flex justify-space-between"
        >
            <template v-if="data.value || data.value !== 'undefined'">
                <span
                    v-if="data.processedIn"
                    class="text-subtitle-2 font-weight-bold"
                >
                    {{ $t(data.processedIn) }}
                </span>
                <span v-else class="text-subtitle-2 font-weight-bold">
                    {{ $t(data.label ? data.label : '') }}
                </span>

                <span
                    v-if="data.isLink"
                    class="text-subtitle-2 text-primary"
                    style="cursor: pointer; color: #1976d2"
                    @click="emit('open-link', data)"
                >
                    {{ data.value }}
                </span>

                <span class="text-subtitle-2" v-else>
                    {{ data.value }}
                </span>
            </template>
        </div>
    </div>
</template>
